export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/fortisimo-icon.svg?cd52fbd6408a9f4f0b25374cad804a27";